<template lang="html">
  <div ref="curator" @click="show = !show" class="aha-row clickable">
    <p :class="{ show: show, fold: english }" v-html="post.title"></p>
    <div class="read-more" v-if="show">
      <img :src="post.files[0].url" :alt="post.title">
      <div class="more-text small" v-html="post.text"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Curator',
  props: {
    post: Object
  },
  data() {
    return {
      show: false,
      english: true
    }
  },
  created() {
    if (this.$route.name === 'english') {
      this.english = true
    }
    window.addEventListener('scroll', this.inViewport)
  },
  destroyed() {
    window.removeEventListener('scroll', this.inViewport)
  },
  methods: {
    inViewport() {
      let hW = window.innerHeight / 2
      let center = window.scrollY + hW
      let top = this.$refs.curator.offsetTop - 4
      let height = top + this.$refs.curator.clientHeight + 4
      if (center > top && center < height) {
        this.$refs.curator.classList.add('active')
      } else {
        this.$refs.curator.classList.remove('active')
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';
.aha-row.clickable {
    .fold {
        padding-right: $gap * 1.25;
        position: relative;
        -webkit-hyphens: none;
        -moz-hyphens: none;
        hyphens: none;
        &:before {
            content: "";
            position: absolute;
            top: 50%;
            right: 5px;
            width: $gap * 0.75;
            height: 0;
            border-top: 2px solid $font-color;
            @media only screen and (max-width: $phone) {
                top: calc(50% - 0px);
                width: $gap * 0.5;
                border-top: 1px solid $font-color;
            }
        }
        &:after {
            content: "";
            position: absolute;
            top: 50%;
            right: 5px;
            width: $gap * 0.75;
            height: 0;
            transform: rotate(90deg);
            border-top: 2px solid $font-color;
            @media only screen and (max-width: $phone) {
                top: calc(50% - 0px);
                width: $gap * 0.5;
                border-top: 1px solid $font-color;
            }
        }
        &.show {
            &:before {
                top: calc(50% + 0px);
                transform: rotate(45deg);
            }
            &:after {
                transform: rotate(135deg);
            }
        }
    }
    &:hover {}
}
.read-more {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    .more-text {
        width: 70%;
        display: inline-block;
        vertical-align: top;
        padding-top: $gap / 2;
        @media only screen and (max-width: 600px) {
            width: 100%;
        }
    }
    img {
        width: 30%;
        display: inline-block;
        vertical-align: top;
        padding-top: $gap / 2;
        padding-right: $gap / 2;
        @media only screen and (max-width: 600px) {
            width: 100%;
            padding-right: 0;
        }
    }
}
</style>
